export const scrollToBottom = (element) => {
  if (!element?.scrollHeight) return
  element.scrollTop = element.scrollHeight
}

export const scrollToSavedPos = (element, savedPos) => {
  if (!element?.scrollHeight) return
  element.scrollTop = element.scrollHeight - savedPos
}
